import {
  TOUR_ADMIN_BOOKING_DETAILS_START,
  TOUR_ADMIN_BOOKING_DETAILS_SUCCESS,
  TOUR_ADMIN_BOOKING_DETAILS_ERROR,
} from '../Constants/BookingDetailsConstants'

const initialState = {
  loading: false,
  booking_detail: [],
};

export default function TourBookingDetailsReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case TOUR_ADMIN_BOOKING_DETAILS_START:
      return {
        ...state,
        booking_detail: [],
        loading: true,
      };
    case TOUR_ADMIN_BOOKING_DETAILS_SUCCESS:
      return {
        ...state,
        booking_detail: action.payload,
        loading: false,
      };
    case TOUR_ADMIN_BOOKING_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
